import FeedbackForm from './FeedbackForm';

export default FeedbackForm;


// WEBPACK FOOTER //
// ./src/components/forms/FeedbackForm/index.js